(function () {
    'use strict';

    angular
        .module('app.addPostToCampaigns')
        .controller('addPostToCampaignsCtrl', ['$scope', '$modal', '$http', '$rootScope', '$modalInstance',
            'addPostToCampaignsService',
            function ($scope, $modal, $http, $rootScope, $modalInstance, advertiserAddInfluencerToCampaignsService) {
                $scope.campaignList = [];

                $scope.selectedAdvertiser = $rootScope.currentUser.company.id;
                if ($rootScope.sideMenuSelections.advertiserId != null || $rootScope.sideMenuSelections.advertiserId !== undefined) {
                    $scope.selectedAdvertiser = $rootScope.sideMenuSelections.advertiserId;
                }

                init();

                ////////////////

                function init() {
                    getAvailableCampaigns();
                }

                function getAvailableCampaigns() {
                    advertiserAddInfluencerToCampaignsService.getAvailableCampaignsToAddPost($scope.selectedAdvertiser, $scope.urlHash)
                        .then(function (response) {
                            $scope.campaignList = response.data;
                        }, function (errorResponse) {
                            $rootScope.handleRequestError(errorResponse, $scope);
                        });
                }

                $scope.selectCampaign = function (campaign) {
                    campaign.ticked = !campaign.ticked;
                }

                $scope.addPost = function () {
                    var selectedCampaigns = _.filter($scope.campaignList, function (item) {
                        return item.ticked === true;
                    }).map(function (item) {
                        return {
                            id: item.id,
                            projectType: item.type.replace(/-/g, '_').toUpperCase() // Ex: 'campaign-creation' -> 'CAMPAIGN_CREATION'
                        };
                    });

                    var params = {
                        postUrlHash: $scope.urlHash,
                        campaigns: selectedCampaigns
                    }

                    advertiserAddInfluencerToCampaignsService.addPostToCampaigns(params)
                        .then(function (response) {
                            $scope.closeModal();
                        }, function (errorResponse) {
                            $rootScope.handleRequestError(errorResponse, $scope);
                        });
                }

                $scope.closeModal = function () {
                    $modalInstance.close();
                }
            }
        ]);
})();
